import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  deleteFilenameTemplates,
  saveFilenameTemplates,
  updateFilenameTemplate,
} from '../../../redux/actions/integrationsConnectionActions';
import fieldNames from './filenameTemplateFields';
import LoadingBar from '../../../components/Modules/LoadingBar/LoadingBar';
import FileFormatConfiguration from './FileFormatConfiguration';
import FolderPathConfiguration from './FolderPathConfiguration';
import DefaultConfigurations from '../DefaultConfigurations';
import CustomizeDescriptionBox from './CustomizeDescriptionBox';
import FieldsSelector from './FieldsSelector';
import SavedFormatPreview from './SavedFormatPreview';
import { notify } from '../../../components/common/Notification';
import './filenameTemplate.less';


class FilenameTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allowFolderConfiguration: this.props.allowFolderConfiguration,

      // 2 sections available
      // folder-path-configuration | file-format-configuration
      editableSection: (
        this.props.allowFolderConfiguration
          ? 'folder-path-configuration'
          : 'file-format-configuration'
      )
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.allowFolderConfiguration !== prevProps.allowFolderConfiguration)
      this.setState({ allowFolderConfiguration: this.props.allowFolderConfiguration });
  }

  getSelectedFieldType = () => {
    const { editableSection } = this.state;
    let selectedFieldType = null;
    if (editableSection === 'file-format-configuration') {
      selectedFieldType = 'selectedFileFormatFields';
    } else if (editableSection === 'folder-path-configuration') {
      selectedFieldType = 'selectedFolderPathFields';
    }
    return selectedFieldType;
  }

  addField = (fieldName) => {
    const selectedFieldType = this.getSelectedFieldType();
    if (selectedFieldType !== null) {
      const selectedFields = this.props.filenameTemplate[selectedFieldType];
      this.props.dispatch(updateFilenameTemplate(this.props.connectionId, { [selectedFieldType]: selectedFields.concat([fieldName]) }));
    }
  }

  removeField = (idx) => {
    const selectedFieldType = this.getSelectedFieldType();
    if (selectedFieldType !== null) {
      const selectedFields = this.props.filenameTemplate[selectedFieldType];
      selectedFields.splice(idx, 1);
      this.props.dispatch(updateFilenameTemplate(this.props.connectionId, { [selectedFieldType]: selectedFields }));
    }
  }

  appendSlashFolderPathFields = () => {
    const { selectedFolderPathFields } = this.props.filenameTemplate;
    const lastElem = selectedFolderPathFields[selectedFolderPathFields.length - 1];
    const fields = selectedFolderPathFields;
    if (lastElem !== '/' && selectedFolderPathFields.length > 0) {
      fields.push('/')
      this.props.dispatch(updateFilenameTemplate(this.props.connectionId, { selectedFolderPathFields: fields }));
    }
    return fields;
  }

  mapFields = (field) => {
    const separatorNames = fieldNames.filter(x => x.type === 'separator').map(f => f.name);
    return separatorNames.includes(field)
      ? field
      : `{{${field}}}`;
  }

  save = () => {
    const { filenameTemplate, connectionId, allowFolderConfiguration } = this.props;
    const selectedFolderPathFields = this.appendSlashFolderPathFields().map(this.mapFields);
    const selectedFileFormatFields = filenameTemplate.selectedFileFormatFields.map(this.mapFields);

    if (filenameTemplate.selectedFileFormatFields.length === 0
      && filenameTemplate.selectedFolderPathFields.length === 0) {
      return this.props.dispatch(deleteFilenameTemplates({ id: connectionId }));
    }

    const template = allowFolderConfiguration
      ? selectedFolderPathFields.concat(selectedFileFormatFields).join('')
      : selectedFileFormatFields.join('');

    const params = {
      id: connectionId,
      date_format: filenameTemplate.date_format,
      description_max_words: filenameTemplate.description_max_words,
      // Folders and filename configuration
      root_folder: filenameTemplate.root_folder,
      template,
    };

    this.props.dispatch(saveFilenameTemplates(params));
  }

  clear = () => {
    const selectedFieldType = this.getSelectedFieldType();
    if (selectedFieldType !== null) {
      this.props.dispatch(updateFilenameTemplate(this.props.connectionId, { [selectedFieldType]: [] }));
    }
  }

  edit = (editableSection) => {
    this.setState({ editableSection });
  }

  addRootFolder = (e) => {
    this.props.dispatch(updateFilenameTemplate(this.props.connectionId, { root_folder: e.target.value }));
  }

  render() {
    const { filenameTemplate, hasAppFolder } = this.props;

    return (
      <div className="filename-template">
        <DefaultConfigurations />

        <CustomizeDescriptionBox />

        <FieldsSelector description_max_words={filenameTemplate.description_max_words}
                        connectionId={this.props.connectionId}
                        date_format={filenameTemplate.date_format}
                        editableSection={this.state.editableSection}
                        root_folder={filenameTemplate.root_folder}
                        addField={this.addField}
                        addRootFolder={this.addRootFolder}
                        hasAppFolder={hasAppFolder}
                        dispatch={this.props.dispatch} />

        <div className="right-panel">
          {this.props.allowFolderConfiguration &&
            <FolderPathConfiguration
              filenameTemplate={filenameTemplate}
              editable={this.state.editableSection === 'folder-path-configuration'}
              addRootFolder={this.addRootFolder}
              removeField={this.removeField}
              edit={() => this.edit('folder-path-configuration')}
              save={this.save}
              clear={this.clear} />
          }

          <FileFormatConfiguration
            filenameTemplate={filenameTemplate}
            editable={this.state.editableSection === 'file-format-configuration'}
            removeField={this.removeField}
            edit={() => this.edit('file-format-configuration')}
            save={this.save}
            clear={this.clear} />
        </div>

        {filenameTemplate.isLoading && <LoadingBar />}

        <SavedFormatPreview filenameTemplate={this.props.filenameTemplate} />
      </div>
    );
  }
}

FilenameTemplate.defaultProps = {
  connectionId: null,
  hasAppFolder: false,
};

FilenameTemplate.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filenameTemplate: PropTypes.object.isRequired,
  connectionId: PropTypes.number,
  hasAppFolder: PropTypes.bool,
};

export default FilenameTemplate;



// WEBPACK FOOTER //
// ./src/Integrations/connections/FilenameTemplate/FilenameTemplate.jsx